import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/survey.ts

var survey_exports = {};

__export(survey_exports, {
  answerSurvey: function answerSurvey() {
    return _answerSurvey;
  },
  getSurvey: function getSurvey() {
    return _getSurvey;
  },
  getSurveyMeta: function getSurveyMeta() {
    return _getSurveyMeta;
  },
  postSurvey: function postSurvey() {
    return _postSurvey;
  },
  updateSurvey: function updateSurvey() {
    return _updateSurvey;
  }
});

var _getSurvey = function _getSurvey(id) {
  return fetcher_default.get("/v4/survey_forms/".concat(id, "/surveys/new"));
};

var _getSurveyMeta = function _getSurveyMeta(code) {
  return fetcher_default.get("/v4/survey_forms/".concat(code));
};

var _postSurvey = function _postSurvey(id, json) {
  return fetcher_default.post("/v4/surveys", {
    answers: json,
    survey_form_id: id
  });
};

var _answerSurvey = function _answerSurvey(surveyID, isDraft, data) {
  return fetcher_default.post("/v4.1/survey_forms/".concat(surveyID, "/surveys"), {
    survey: {
      is_draft: isDraft,
      survey_answers_attributes: data
    }
  });
};

var _updateSurvey = function _updateSurvey(surveyID, isDraft, data) {
  return fetcher_default.put("/v4.1/surveys/".concat(surveyID), {
    survey: {
      is_draft: isDraft,
      survey_answers_attributes: data
    }
  });
};

export { _getSurvey as getSurvey, _getSurveyMeta as getSurveyMeta, _postSurvey as postSurvey, _answerSurvey as answerSurvey, _updateSurvey as updateSurvey, survey_exports };